// frontend/src/components/landing/sections/LandingFooter.js
import React from 'react';
import { Box, Link, Typography } from '@mui/material';
import { Container } from '../parts';
import { tokens } from '../landingTheme';

const PHOTO_URL = 'https://commons.wikimedia.org/wiki/File:A_science_classroom_in_a_modern_public_high_school_in_the_United_States_%E2%80%93_Hayesville_High_School_in_Clay_County,_North_Carolina_02.jpg';
const LICENSE_URL = 'https://creativecommons.org/licenses/by/4.0/';

const linkSx = {
    color: 'inherit',
    textDecorationColor: 'rgba(75, 85, 101, 0.4)',
    '&:hover': { color: tokens.ink },
    '&:focus-visible': { outline: `2px solid ${tokens.accent}`, outlineOffset: 2 },
};

const LandingFooter = () => (
    <Box component="footer" sx={{ borderTop: `1px solid ${tokens.line}`, py: 4 }}>
        <Container
            sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                justifyContent: 'space-between',
                gap: 1.5,
            }}
        >
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
                ADAS · Automated Discourse Analysis System
            </Typography>
            <Typography variant="body2" sx={{ color: tokens.inkMuted }}>
                Photo:{' '}
                <Link href={PHOTO_URL} target="_blank" rel="noopener noreferrer" sx={linkSx}>
                    Harrison Keely, Hayesville High School science classroom
                </Link>
                ,{' '}
                <Link href={LICENSE_URL} target="_blank" rel="noopener noreferrer license" sx={linkSx}>
                    CC BY 4.0
                </Link>
                , via Wikimedia Commons · Example utterances are made up.
            </Typography>
        </Container>
    </Box>
);

export default LandingFooter;
